import {Component, HostListener, ViewChild, inject, input} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {myAppConfig} from '../../../settings';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {NgIf, NgFor, JsonPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-localstorage-info',
    templateUrl: './localstorage-info.component.html',
    styleUrl: './localstorage-info.component.scss',
    imports: [ModalDirective, NgIf, FormsModule, NgFor, JsonPipe]
})
export class LocalstorageInfoComponent {

    private toastrService = inject(ToastrService);

    @ViewChild('staticModal') modalDiv: any;
    // The key that will show the info modal
    key = input<string>('q');

    keys: any[] = [];

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent): void {
        event.preventDefault();
        if (event.ctrlKey && event.key === this.key()) {
            this.getKeys();
            this.modalDiv.show();
        }
    }

    getKeys(): void {
        // get all localStorage keys
        this.keys = Object.keys(localStorage);

        // filter only those which belong to the app according to the settings
        this.keys = this.keys.filter(key => {
            return key.startsWith(myAppConfig.appID);
        }).map(key => {
            return {name: key, checked: false, show: false};
        });
    }

    remove(): void {
        this.keys.forEach(key => {
            if (key.checked) {
                localStorage.removeItem(key.name);
            }
        });
        this.getKeys();
        this.toastrService.info('Items were deleted!');
    }

    showInfo(key: any): void {
        key.show = !key.show;
        const info = localStorage.getItem(key.name);
        if (info) {
            key.data = JSON.parse(info);
        }
    }

    selectAll(): void {
        this.keys.forEach(key => {
            key.checked = true;
        });
    }

    deselectAll(): void {
        this.keys.forEach(key => {
            key.checked = false;
        });
    }
}
